import { render } from "./SuperAdminDatatableTDClinicTitle.vue?vue&type=template&id=a36e0914&scoped=true"
import script from "./SuperAdminDatatableTDClinicTitle.vue?vue&type=script&lang=js"
export * from "./SuperAdminDatatableTDClinicTitle.vue?vue&type=script&lang=js"

import "./SuperAdminDatatableTDClinicTitle.vue?vue&type=style&index=0&id=a36e0914&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a36e0914"]])

export default __exports__